import React from 'react';
import './styles.css';

interface VideoPlayerProps {
  videoUrl: string;
  videoType: string;
  fallbackImageUrl?: string;
  width: number | string;
  aspectRatio: number;
  alt?: string;
}

// An HTML5 video player. This is tailored to the download page, and the specific video we use.
const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoUrl,
  videoType,
  fallbackImageUrl,
  width,
  aspectRatio,
  alt,
}) => {
  const containerStyle: React.CSSProperties = {
    width,
    aspectRatio: aspectRatio.toString(),
  };

  return (
    <div className="download-video-player-container" style={containerStyle}>
      <div className="download-video-player-wrapper">
        <video
          width="100%"
          height="100%"
          autoPlay
          muted
          loop
          playsInline
          poster={fallbackImageUrl}
          className="download-video-player-media"
          aria-label={alt}
        >
          <source src={videoUrl} type={videoType} />
          {fallbackImageUrl && (
            <img
              src={fallbackImageUrl}
              alt={alt}
              className="download-video-player-media"
            />
          )}
          Your browser does not support inline videos.
        </video>
      </div>
    </div>
  );
};

VideoPlayer.defaultProps = {
  fallbackImageUrl: undefined,
  alt: undefined,
};

export default VideoPlayer;
